import React from 'react'

interface LoaderProps {
    /** Whether to show as an overlay covering the parent container */
    overlay?: boolean
}

/**
 * Reusable loader component with the standard self-building-square-spinner.
 * Use overlay={true} to cover a relative-positioned parent container.
 */
const Loader: React.FC<LoaderProps> = ({overlay = false}) => {
    const spinner = (
        <div className="self-building-square-spinner">
            <div className="square bg-primary-800"/>
            <div className="square bg-primary-800"/>
            <div className="square bg-primary-800"/>
            <div className="square clear bg-primary-800"/>
            <div className="square bg-primary-800"/>
            <div className="square bg-primary-800"/>
            <div className="square clear bg-primary-800"/>
            <div className="square bg-primary-800"/>
            <div className="square bg-primary-800"/>
        </div>
    )

    if (overlay) {
        return (
            <div className="absolute inset-0 z-20 bg-white/70 flex items-center justify-center">
                {spinner}
            </div>
        )
    }

    return spinner
}

export default Loader
